<template>
  <div>
    <b-card>
      <!-- <swiper class="swiper" :options="swiperOptions"> -->
      <!-- v-for="(item, index) in 6" :key="index" -->
      <!-- <swiper-slide v-for="(item, index) in cards" :key="('item-', +index)"> -->
      <!-- <div
            class="gray-card cursor-pointer"
            @click="handleclick(item.route)"
          > -->
      <!-- <b-card
              :title="item.title"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize21px"
            > -->
      <!-- <b-card-text class="fsize21px"
                ><b>{{ item.text }}</b>
                <b-button
                  class="btn-p20 ml-10"
                  v-if="item.id === '04'"
                  variant="primary"
                  >withdraw</b-button
                > -->
      <!-- </b-card-text>
            </b-card>
          </div>
        </swiper-slide> -->
      <!-- </swiper> -->
      <swiper class="swiper" :options="swiperOptions">
        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick(adminTable)"
          >
            <b-card
              title="Total Service Provider"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize20 shadow-md"
            >
              <b-card-text class="fsize21px"
                ><b>{{
                  get_all_count[0].adminApprove
                    ? get_all_count[0].adminApprove
                    : 0
                }}</b>
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick(applicationReqTable)"
          >
            <b-card
              title="Service Provider Applications"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize20 shadow-md"
            >
              <b-card-text class="fsize21px"
                ><b>{{
                  get_all_count[0].adminHold ? get_all_count[0].adminHold : 0
                }}</b>
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick(withdrawReqTable)"
          >
            <b-card
              title="Service Provider Withdraw"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize20 shadow-md"
            >
              <b-card-text class="fsize21px"
                ><b>{{ requestCount }}</b>
                <!-- <b-button class="btn-p20 ml-10" variant="primary"
                  >withdraw</b-button
                > -->
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick('service-provider-details')"
          >
            <b-card
              title="Service Provider Details"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize20 shadow-md"
            >
              <b-card-text class="fsize21px"
                ><b>{{
                  this.get_all_count[0].adminHold
                    ? this.get_all_count[0].adminHold
                    : 0
                }}</b>
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>

        <div class="swiper-button-prev adminswiper" slot="button-prev"></div>
        <div class="swiper-button-next adminswiper" slot="button-next"></div>
      </swiper>
    </b-card>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      requestCount: 0,
      adminTable: "admin-table",
      applicationReqTable: "application-reqTable",
      withdrawReqTable: "withdraw-reqTable",
      // cards: [
      //   {
      //     id: "01",
      //     title: "Total Volunteer",
      //     text: "1000",
      //     route: "admin-table",
      //   },
      //   {
      //     id: "02",
      //     title: "Application Requests",
      //     text: "1000",
      //     route: "application-reqTable",
      //   },
      //   {
      //     id: "03",
      //     title: "Withdraw Request",
      //     text: "100",
      //     route: "withdraw-reqTable",
      //   },
      // ],
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    async handleclick(route) {
      const payload = {
        _id: this.user._id,
      };
      try {
        await this.$store.dispatch("respitecare/get_allbooking", payload);
      } catch (error) {}
      this.$router.push({ name: route });
    },
    function() {
      // console.log(this.user);
    },
    async getAllCounts() {
      try {
        await this.$store.dispatch("respitecare/get_all_count");
        await this.$store.dispatch("respitecare/getAllWithdrawal", {
          limit: 1,
        });
        // console.log(this.allWithdrawalRequest);
        this.requestCount = this.allWithdrawalRequest.totalCount;
        // this.adminApprove = this.get_all_count[0].adminApprove;
        // this.adminHold = this.get_all_count[0].adminHold;
        // console.log(this.adminApprove, this.adminHold);
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState("auth", { user: "user" }),
    ...mapState("respitecare", ["get_all_count", "allWithdrawalRequest"]),
  },
  async mounted() {
    this.function();
    await this.getAllCounts();
  },
};
</script>

<style>
.fsize21px {
  font-size: 21px;
}
.btn-p20 {
  padding: 6px 20px !important;
}
.adminswiper.swiper-button-next,
.swiper-button-prev {
  height: 27px !important;
}
</style>
